import type { Mouvement } from '@mairistem/comptabilite';
import { UserRole } from '@mairistem/finances-utils';
import BordereauStateStep from '../../../constants/liquidation/bordereaux/BordereauStateStep';
import BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import type BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type MouvementActionType from '../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import MouvementModifierAction from '../../mouvements/liquidation/actions/MouvementModifierAction';
import type BaseLiquidationAction from '../../pieces/BaseLiquidationAction';
import BordereauActualiseEtatAction from '../actions/BordereauActualiseEtatAction';
import BordereauAnnulerAction from '../actions/BordereauAnnulerAction';
import BordereauDupliquerAction from '../actions/BordereauDupliquerAction';
import BordereauMettreEnEchecAction from '../actions/BordereauMettreEnEchecAction';
import BaseBordereauState from './BaseBordereauState';

class BordereauAttenteSignatureState extends BaseBordereauState {
	constructor() {
		super();
		this.step = BordereauStateStep.ATTENTE_SIGNATURE;
		this.state = BordereauStateType.ATTENTE_SIGNATURE;
		this.color = '#EB4BE4';
		this.libelle = 'Attente signature';
	}

	getBordereauActions(
		_bordereau: BordereauWithState,
		userRole: UserRole,
	): BaseLiquidationAction<BordereauWithState, BordereauActionType>[] {
		return [
			new BordereauActualiseEtatAction({ isActionPrincipale: true }),
			new BordereauDupliquerAction(),
			new BordereauAnnulerAction(),
			...(userRole === UserRole.ADMIN
				? [new BordereauMettreEnEchecAction({ isSuperUser: true })]
				: []),
		];
	}

	getMouvementActions(
		userRole: UserRole,
	): BaseLiquidationAction<Mouvement, MouvementActionType>[] {
		return [
			new MouvementModifierAction({ isReadonly: true }),
			...this.getActionsAnnulationRejet(),
			...(userRole === UserRole.ADMIN
				? [
						new MouvementModifierAction({
							isSuperUser: true,
							isReadonly: false,
						}),
					]
				: []),
		];
	}
}

export default BordereauAttenteSignatureState;
